import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form, Grid, Modal } from 'semantic-ui-react';
import moment from 'moment';

// Actions
import {
    requestCreateTimesheet
    // @ts-ignore
} from 'services/timesheet/actions';

// Global Components
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';
// @ts-ignore
import EntityOptions from 'components/EntityOptions';
// @ts-ignore
import EntityTypeName from 'components/EntityTypeName';
// @ts-ignore
import WorkTypeOptions from 'components/WorkTypeOptions';
// @ts-ignore
import GroupDropdownFilterDropdown from 'components/GroupDropdownFilterDropdown';
// @ts-ignore
import GroupOptions from 'components/GroupOptions';
import QueryStringModal from 'components/QueryStringModal';
import WeekDropdown from 'components/WeekDropdown';

// Form
import { normalizers, validators, RenderTextArea, RenderDropdown } from 'forms';

// Types
import { AppState } from 'services/types';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';

import { validateTimesheet } from 'forms/validate';
import FieldValues from 'components/FieldValues';

import SubmittingSection from 'components/SubmissionSection';
// Local Components
// @ts-ignore
import TimeOptions from '../../../../components/TimeOptions';
// @ts-ignore
import WorkTypeEntityTypeId from '../../../../components/WorkTypeEntityTypeId';
import GroupTimesheetAlreadyExistGate from './components/GroupTimesheetAlreadyExistGate';

// Local Selectors
import { selectInitialValues } from './selectors';
import { makeSelectGroupTimesheetAlreadyExistLength } from './components/GroupTimesheetAlreadyExistGate/selectors';
import GroupTimesheetAlreadyExistButton from './components/GroupTimesheetAlreadyExistButton';

// Normalizers
const { toNull } = normalizers;

// Validators
const { isRequired } = validators;

// Constants
const NAMESPACE = ['TIMESHEET_CREATE', 'TIMESHEET_UPDATE'];
const QUERY_STRING_PARAM = 'groupTimesheetModal';

// Types
interface ConnectedProps {
    initialValues?: Record<string, any>;
    groupTimesheetAlreadyExistLength: number;
}

interface DispatchProps {
    requestCreateTimesheet: Function;
}

type Props = ConnectedProps & DispatchProps;

export class GroupTimesheetModal extends React.PureComponent<Props> {
    handleSubmit = (values: any): void => {
        const { weekDate, ...timesheet } = values;
        const startDate = weekDate;
        const endDate = moment(weekDate, 'YYYY-MM-DD')
            .add(6, 'days')
            .format('YYYY-MM-DD');

        this.props.requestCreateTimesheet({
            ...timesheet,
            startDate,
            endDate
        });
    };

    render(): React.ReactElement {
        const { initialValues } = this.props;

        return (
            <QueryStringModal param={QUERY_STRING_PARAM}>
                <ErrorBoundary
                    namespace="GroupTimesheetModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Create Group Timesheet</Modal.Header>
                    <Modal.Content className="constrain-width">
                        <FinalForm
                            onSubmit={this.handleSubmit}
                            initialValues={initialValues}
                            subscription={{}}
                            validate={validateTimesheet}
                            render={(props: any): any => {
                                const { handleSubmit } = props;

                                return (
                                    <Form
                                        autoComplete="off"
                                        onSubmit={handleSubmit}
                                    >
                                        <Grid className="column-padding">
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <WeekDropdown
                                                        name="weekDate"
                                                        validate={isRequired}
                                                    />
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <GroupOptions>
                                                        {(
                                                            options: any
                                                        ): any => (
                                                            <Field
                                                                name="groupId"
                                                                label="Group"
                                                                placeholder="Add group"
                                                                parse={toNull}
                                                                fluid
                                                                component={
                                                                    RenderDropdown as any
                                                                }
                                                                subscription={{
                                                                    value: true,
                                                                    touched:
                                                                        true,
                                                                    error: true
                                                                }}
                                                                options={
                                                                    options
                                                                }
                                                                search
                                                                selection
                                                                closeOnChange
                                                                upward={false}
                                                                clearable
                                                                selectOnBlur={
                                                                    false
                                                                }
                                                                renderOptions={
                                                                    <GroupDropdownFilterDropdown />
                                                                }
                                                                validate={
                                                                    isRequired
                                                                }
                                                            />
                                                        )}
                                                    </GroupOptions>
                                                </Grid.Column>
                                                <Grid.Column
                                                    width={16}
                                                    style={{
                                                        marginTop: -12,
                                                        marginBottom: 14,
                                                        fontSize: 12
                                                    }}
                                                >
                                                    <FieldValues
                                                        fieldNames={[
                                                            'groupId',
                                                            'weekDate'
                                                        ]}
                                                    >
                                                        {({
                                                            groupId,
                                                            weekDate
                                                        }): React.ReactElement => (
                                                            <GroupTimesheetAlreadyExistGate
                                                                groupId={
                                                                    groupId
                                                                }
                                                                startDate={
                                                                    weekDate
                                                                }
                                                            >
                                                                <GroupTimesheetAlreadyExistButton
                                                                    groupId={
                                                                        groupId
                                                                    }
                                                                    startDate={
                                                                        weekDate
                                                                    }
                                                                />
                                                            </GroupTimesheetAlreadyExistGate>
                                                        )}
                                                    </FieldValues>
                                                </Grid.Column>
                                                <Grid.Column
                                                    mobile={16}
                                                    tablet={8}
                                                    computer={8}
                                                >
                                                    <Field
                                                        name="endTime"
                                                        subscription={{
                                                            value: true
                                                        }}
                                                    >
                                                        {({
                                                            input: { value }
                                                        }): React.ReactElement => (
                                                            <TimeOptions
                                                                isStart
                                                                endTime={value}
                                                            >
                                                                {(
                                                                    options: any
                                                                ): React.ReactElement => (
                                                                    <Field
                                                                        component={
                                                                            RenderDropdown as any
                                                                        }
                                                                        name="startTime"
                                                                        subscription={{
                                                                            value: true,
                                                                            touched:
                                                                                true,
                                                                            error: true
                                                                        }}
                                                                        options={
                                                                            options
                                                                        }
                                                                        label="Start Time (optional)"
                                                                        placeholder="Enter start time"
                                                                        parse={
                                                                            toNull
                                                                        }
                                                                        fluid
                                                                        search
                                                                        selection
                                                                        clearable
                                                                        selectOnBlur={
                                                                            false
                                                                        }
                                                                    />
                                                                )}
                                                            </TimeOptions>
                                                        )}
                                                    </Field>
                                                </Grid.Column>
                                                <Grid.Column
                                                    mobile={16}
                                                    tablet={8}
                                                    computer={8}
                                                >
                                                    <Field
                                                        name="startTime"
                                                        subscription={{
                                                            value: true
                                                        }}
                                                    >
                                                        {({
                                                            input: { value }
                                                        }): React.ReactElement => (
                                                            <TimeOptions
                                                                isEnd
                                                                startTime={
                                                                    value
                                                                }
                                                            >
                                                                {(
                                                                    options: any
                                                                ): React.ReactElement => (
                                                                    <Field
                                                                        component={
                                                                            RenderDropdown as any
                                                                        }
                                                                        subscription={{
                                                                            value: true,
                                                                            touched:
                                                                                true,
                                                                            error: true
                                                                        }}
                                                                        options={
                                                                            options
                                                                        }
                                                                        name="endTime"
                                                                        label="End Time (optional)"
                                                                        placeholder="Enter end time"
                                                                        parse={
                                                                            toNull
                                                                        }
                                                                        fluid
                                                                        search
                                                                        selection
                                                                        clearable
                                                                        selectOnBlur={
                                                                            false
                                                                        }
                                                                    />
                                                                )}
                                                            </TimeOptions>
                                                        )}
                                                    </Field>
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <WorkTypeOptions>
                                                        {(
                                                            options: any
                                                        ): any => (
                                                            <Field
                                                                name="workTypeId"
                                                                label="Task (optional)"
                                                                placeholder="Add task"
                                                                parse={toNull}
                                                                fluid
                                                                component={
                                                                    RenderDropdown as any
                                                                }
                                                                subscription={{
                                                                    value: true,
                                                                    touched:
                                                                        true,
                                                                    error: true
                                                                }}
                                                                options={
                                                                    options
                                                                }
                                                                search
                                                                selection
                                                                closeOnChange
                                                                upward={false}
                                                                clearable
                                                                selectOnBlur={
                                                                    false
                                                                }
                                                            />
                                                        )}
                                                    </WorkTypeOptions>
                                                </Grid.Column>
                                                <Grid.Column width="16">
                                                    <Field
                                                        name="workTypeId"
                                                        subscription={{
                                                            value: true
                                                        }}
                                                    >
                                                        {({
                                                            input: { value }
                                                        }: any): any => (
                                                            <WorkTypeEntityTypeId
                                                                workTypeId={
                                                                    value
                                                                }
                                                            >
                                                                {(
                                                                    entityTypeId: number
                                                                ): React.ReactElement => (
                                                                    <EntityTypeName
                                                                        entityTypeId={
                                                                            entityTypeId
                                                                        }
                                                                    >
                                                                        {(
                                                                            entityTypeName: string
                                                                        ): React.ReactElement => (
                                                                            <EntityOptions
                                                                                entityTypeId={
                                                                                    entityTypeId
                                                                                }
                                                                            >
                                                                                {(
                                                                                    options: any
                                                                                ): React.ReactElement => (
                                                                                    <Field
                                                                                        component={
                                                                                            RenderDropdown as any
                                                                                        }
                                                                                        subscription={{
                                                                                            value: true,
                                                                                            touched:
                                                                                                true,
                                                                                            error: true
                                                                                        }}
                                                                                        options={
                                                                                            options
                                                                                        }
                                                                                        name="entityId"
                                                                                        label={`${
                                                                                            entityTypeName ||
                                                                                            'Area'
                                                                                        }`}
                                                                                        placeholder={`Add ${
                                                                                            entityTypeName
                                                                                                ? entityTypeName.toLowerCase()
                                                                                                : 'area'
                                                                                        }`}
                                                                                        fluid
                                                                                        search
                                                                                        selection
                                                                                        clearable
                                                                                        selectOnBlur={
                                                                                            false
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </EntityOptions>
                                                                        )}
                                                                    </EntityTypeName>
                                                                )}
                                                            </WorkTypeEntityTypeId>
                                                        )}
                                                    </Field>
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <Field
                                                        name="comment"
                                                        component={
                                                            RenderTextArea as any
                                                        }
                                                        subscription={{
                                                            value: true,
                                                            touched: true,
                                                            error: true
                                                        }}
                                                        label="Comment (optional)"
                                                        type="text"
                                                        placeholder="Enter comment"
                                                        parse={toNull}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        <ErrorAlert namespace={NAMESPACE} />
                                        <SubmittingSection
                                            submittingButtonParam={{
                                                namespace: NAMESPACE
                                            }}
                                            queryStringCancelButtonParam={{
                                                params: {
                                                    [QUERY_STRING_PARAM]:
                                                        undefined
                                                },
                                                ignoreActive: false
                                            }}
                                        />
                                    </Form>
                                );
                            }}
                        />
                    </Modal.Content>
                </ErrorBoundary>
            </QueryStringModal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    initialValues: selectInitialValues,
    groupTimesheetAlreadyExistLength:
        makeSelectGroupTimesheetAlreadyExistLength()
});

export default connect(mapStateToProps, {
    requestCreateTimesheet
})(GroupTimesheetModal);
